import { render, staticRenderFns } from "./BrickFilterSettings.vue?vue&type=template&id=3f0dc56e&"
import script from "./BrickFilterSettings.vue?vue&type=script&lang=js&"
export * from "./BrickFilterSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f0dc56e')) {
      api.createRecord('3f0dc56e', component.options)
    } else {
      api.reload('3f0dc56e', component.options)
    }
    module.hot.accept("./BrickFilterSettings.vue?vue&type=template&id=3f0dc56e&", function () {
      api.rerender('3f0dc56e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickFilterSettings.vue"
export default component.exports